import { PaginatedDto, PaginatedQuery } from "@core/data/dto/paginated.dto";
import type { Undefinable } from "@core/domain/types/undefinable.type";
import { Type } from "class-transformer";
import {
    IsArray,
    IsBoolean,
    IsDateString,
    IsInt,
    IsNotEmpty,
    IsOptional,
    IsString,
} from "class-validator";

export class ProjectKanbanBlockDto {
    @IsInt()
    @IsNotEmpty()
    readonly id!: number;

    @IsDateString()
    @IsOptional()
    readonly created!: string;

    @IsDateString()
    @IsOptional()
    readonly modified!: string;

    @IsBoolean()
    @IsOptional()
    readonly is_active!: boolean;

    @IsInt()
    @IsNotEmpty()
    readonly project!: number;

    @IsString()
    @IsNotEmpty()
    readonly name!: string;

    @IsInt()
    @IsNotEmpty()
    readonly position!: number;

    @IsString()
    @IsOptional()
    readonly phase!: string;
}

export class ProjectKanbanBlocksDto extends PaginatedDto {
    @IsArray()
    @IsNotEmpty()
    @Type(() => ProjectKanbanBlockDto)
    readonly results!: ProjectKanbanBlockDto[];
}

export type ProjectKanbanBlockQuery = PaginatedQuery & {
    project?: Undefinable<number>;
    phase?: Undefinable<string>;
};
